import React, { useContext } from "react"
import {MainContext} from "../../helpers/MainContext"

const RentInformButton = () => {
    const { setObjectRentFormVisibility } = useContext(MainContext);

    const handleClickOnRentInform = (e) => {
        e.preventDefault();
        setObjectRentFormVisibility(true);
    }

    return (
        <button className="button notifyOnChangeInRent" onClick={handleClickOnRentInform}>
            <i>
                Сообщить об <br/>освобождении
            </i>
        </button>
    );
}

export default RentInformButton;